import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { VersionValidatorItem } from 'store';

const { mapGetters } = createNamespacedHelpers('versions');

/**
 * Receives component as children and by using scoped slots, pass information about its availability in current version,
 * based on version set in store. Information from which version component is available is passed through props
 */
@Component({
	computed: {
		...mapGetters({
			currentVersion: 'getCurrentVersion'
		}),
		isAvailable() {
			const currVer: number = this.currentVersion.value;
			const versionFrom: number = this.versionInfo.versionFrom ? parseInt(this.versionInfo.versionFrom.split('.').join(''), 10) : 0;
			const versionTo = this.versionInfo.versionTo ? parseInt(this.versionInfo.versionTo.split('.').join(''), 10) : 0;

			return (currVer >= versionFrom || !versionFrom) && (currVer <= versionTo || !versionTo);
		}
	}
})
export default class WithVersionValidator extends Vue {
	@Prop({
		default() {
			return {
				versionFrom: 0,
				versionTo: 0
			};
		}
	})
	readonly versionInfo!: VersionValidatorItem;

	@Prop({
		default: 'div'
	})
	readonly tag!: string;
}
